import React from 'react';
import { withRouter } from 'react-router-dom';

import Button from '../Global/Button';

import image404 from '../../assets/images/404.png';

const Error404 = (props) => {
    return (
        <div className="page404">
            <img src={image404} alt="404 error" />
            <h1 className="page404__title">
                Žao nam je! Stranica koju tražite ne postoji!
            </h1>
            <Button color="black" text="Vrati me na početnu!" onClick={() => {props.history.replace('/')}} />
        </div>
    );
}

export default withRouter(Error404);